import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import { getMultiplePosturalExamPDF, getPosturalExaminationData, getPosturalExamPDF } from "./utils";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack5";
import { Button, Space } from "antd";

import fileDownload from "js-file-download";
import { getPatient } from "../patients/utils";
import { Patient } from "../patients/interfaces";
import { PosturalExamination } from "./interfaces";
import { LoadingOutlined } from "@ant-design/icons";

const ExamPDF = () => {
  const { id } = useParams();
  const { examId } = useParams();
  const { examsIds } = useParams();
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [uint8ArrayPDF, setU8PDF] = useState<Uint8Array | undefined>(undefined);
  const [dataPDF, setDataPDF] = useState<Blob | undefined>(undefined);
  const [patient, setPatient] = useState<Patient>();
  // const [exam, setExam] = useState<PosturalExamination>();
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const patientId = parseInt(id || "");
    const examIdNum = parseInt(examId || "");
    
    // Guard against invalid IDs
    if (isNaN(patientId) || patientId <= 0) {
      console.error("Invalid patient ID:", id);
      return;
    }
    
    if(examsIds)
    { 
      getMultiplePosturalExamPDF(
        signedInDoctor,
        patientId,
        (examsIds.split("-").map(Number) || [])
      ).then((pdfBlob) => {
        if (pdfBlob) {
          setDataPDF(pdfBlob);
          new Response(pdfBlob)
            .arrayBuffer()
            .then((u8data) => setU8PDF(new Uint8Array(u8data)));
        }
      });
    }
    else if (!isNaN(examIdNum) && examIdNum > 0) {
      getPosturalExamPDF(
        signedInDoctor,
        patientId,
        examIdNum
      ).then((pdfBlob) => {
        if (pdfBlob) {
          setDataPDF(pdfBlob);
          new Response(pdfBlob)
            .arrayBuffer()
            .then((u8data) => setU8PDF(new Uint8Array(u8data)));
        }
      });
    } else {
      console.error("Invalid exam ID:", examId);
    }

    getPatient(signedInDoctor, patientId).then((fetchedPatient) =>
      setPatient(fetchedPatient)
    );
    
    // if(examId) // TODO Leo fix
    //   getPosturalExaminationData(
    //     signedInDoctor,
    //     parseInt(id || ""),
    //     parseInt(examId || ""),
    //     false
    //   ).then((fetchedExam) => setExam(fetchedExam));
  }, []);
  const downloadPDF = () => {
    const fileName =
      (patient //&& exam
        ? patient.name + "-" + patient.surname + "_" + (examsIds || examId)//exam.type
        : id + "_" + examId) + ".pdf";
    if (dataPDF) fileDownload(dataPDF, fileName);
  };

  const printPDF = () => {
    if (uint8ArrayPDF) {
      const blob = new Blob([uint8ArrayPDF], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url);
      if (newWindow) {
        newWindow.print();
      }
    }
  };

  return (
    <div style={{ marginLeft: "32px", marginTop: "32px" }}>
      {!loaded && <Space><LoadingOutlined rev={true}/></Space>}
      <Document
        file={{ data: uint8ArrayPDF }}
        onLoadSuccess={({ numPages }: { numPages: number }) =>
          {
            setNumPages(numPages),
            setLoaded(true)
          }
        }
      >
        <Page pageNumber={pageNumber} />
      </Document>
      <p>
        Page {pageNumber} of {numPages}
      </p>
      <Button onClick={() => downloadPDF()}>Download</Button>
      <Button onClick={() => printPDF()} style={{ marginLeft: "10px" }}>
        Stampa
      </Button>
    </div>
  );
};

export default ExamPDF;
